import React from 'react'
import {
  OrderDetailsCtaWmo,
} from './style/buttonWMO.css'

export const returnType = {
  default: 'default',
  lifetime: 'lifetime',
}

export const lifetimeButton = {
  claim: {
    label: 'Lifetime Replacement Claimed',
    Button: OrderDetailsCtaWmo,
    disabled: true,
    withChat: false,
  },
  selectItem: {
    label: 'Select Item',
    Button: OrderDetailsCtaWmo,
    disabled: false,
    withChat: false,
  },
  selectItemDisabled: {
    label: 'Select Item',
    Button: OrderDetailsCtaWmo,
    disabled: true,
    withChat: false,
  },
  ineligible: {
    label: 'Lifetime Replacement Ineligible',
    Button: OrderDetailsCtaWmo,
    disabled: true,
    withChat: true,
  },
  empty: {
    label: '',
    Button: function Button() { return <></> },
    disabled: true,
  },
}
